import template from './page-home-app.html';
import controller from './page-home-app.controller';
import './page.scss';

let pageHomeAppComponent = {
  bindings: {},
  template,
  controller
};

export default pageHomeAppComponent;



// WEBPACK FOOTER //
// ./client/app/components/page/page-home-app.component.js